module.exports = __webpack_public_path__ + "assets/fonts/Montserrat-Medium.a98626e1-ps.ttf";